import React, { VFC } from 'react'

import { useSnackbar as useNotiSnackbar } from 'notistack'

import { Toast } from 'src/components/atoms'

type Props = {
  id: string | number
  text: string | React.ReactNode
  icon?: React.ReactNode
  forwardRef?: React.ForwardedRef<any>
}

const BaseErrorToast: VFC<Props> = ({ id, forwardRef, text, icon }) => {
  const { closeSnackbar } = useNotiSnackbar()
  return (
    <Toast
      ref={forwardRef}
      text={text}
      icon={icon}
      type="error"
      onClickClose={() => closeSnackbar(id)}
    />
  )
}

// MUIのsnackbarでSlideを使用する場合にforwardRefを使用する必要がある
export const ErrorToast = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <BaseErrorToast {...props} forwardRef={ref} />
})
